import { Component, OnInit } from '@angular/core'
import { QuoteReviewService } from '../../quote-review/services/quote-review.service'
import {
  GlobalMessageService,
  GlobalMessageType,
  AuthService,
  TranslationService,
} from '@spartacus/core'
import { saveAs } from 'file-saver'
import { QuoteCartService } from '../../quote-services/quote-cart.service'
import { QuoteCheckoutService } from '../../quote-checkout/services/quote-checkout.service'
import { Router } from '@angular/router'
import { BreadcrumbService } from '../../../../shared/components/breadcrumb/breadcrumb.service'

@Component({
  standalone: false,
  selector: 'app-quote-confirmation',
  templateUrl: './quote-confirmation.component.html',
  styleUrls: ['./quote-confirmation.component.scss'],
})
export class QuoteConfirmationComponent implements OnInit {
  public code
  notificationEmail: string
  private cartId: string
  public userType: string
  public loggedIn: boolean
  constructor(
    private quoteReviewService: QuoteReviewService,
    private breadCrumbService: BreadcrumbService,
    private globalMessageService: GlobalMessageService,
    private quoteCartService: QuoteCartService,
    private auth: AuthService,
    private quoteCheckoutService: QuoteCheckoutService,
    private translate: TranslationService,
    public router: Router
  ) {}

  ngOnInit(): void {
    this.auth.isUserLoggedIn().subscribe(
      (success) => {
        this.loggedIn = success
        if (this.loggedIn) {
          this.userType = 'current'
          sessionStorage.removeItem('userType-anonymous')
          sessionStorage.removeItem('cartId-anonymous')
          sessionStorage.removeItem('cartStatus-anonymous')
        }
        if (!this.loggedIn) {
          this.userType = 'anonymous'
          sessionStorage.removeItem('userType-current')
          sessionStorage.removeItem('cartId-current')
          sessionStorage.removeItem('cartStatus-current')
        }
        this.cartId =
          sessionStorage.getItem('cartId-' + this.userType) || undefined
        sessionStorage.setItem('userType-' + this.userType, this.userType)
      },
      (error) => {}
    )

    this.breadCrumbService.setBreadCrumbs([])
    this.translate
      .translate('quoteConfirmation.quoteConfirm')
      .subscribe((res: string) =>
        this.breadCrumbService.setBreadcrumbTitle(res)
      )

    this.code =
      this.quoteReviewService.getCode() || sessionStorage.getItem('quote-code')
    this.notificationEmail = sessionStorage.getItem('notificationEmail')
    this.getQuoteCart()
    if (!this.code) {
      this.globalMessageService.add(
        { key: 'quoteConfirmation.notAbleToGetCode' },
        GlobalMessageType.MSG_TYPE_ERROR,
        10000
      )
      this.code = 'Code not found'
    }
  }
  getQuoteCart() {
    this.cartId = undefined
    this.quoteCartService.getCart(this.cartId, this.userType).subscribe(
      (cart) => {
        if (this.userType === 'current') {
          this.cartId = cart['code']
        } else {
          this.cartId = cart['guid']
        }
        sessionStorage.setItem('cartId-' + this.userType, this.cartId)
        sessionStorage.setItem('cartStatus-' + this.userType, 'empty')
        sessionStorage.setItem(
          'quoteCart-requestedDate',
          new Date().toISOString()
        )
      },
      (error) => {
        if (error.status === 400) {
          this.cartId = undefined
          this.getQuoteCart()
        }
      }
    )
  }
  downloadPDF() {
    this.quoteReviewService
      .downloadQuoteCnfPdf(this.userType, this.code)
      .subscribe((res) => {
        if (res !== null && res !== undefined) {
          let fileName = 'rfqsubmission'
          const blob = new Blob([res], { type: 'application/pdf' })
          const file = new File([blob], fileName + '.pdf', {
            type: 'application/pdf',
          })
          saveAs(file)
        } else {
          this.globalMessageService.add(
            { key: 'quoteConfirmation.pdfNotAvailable' },
            GlobalMessageType.MSG_TYPE_ERROR,
            10000
          )
        }
      })
  }

  ngOnDestroy() {
    if (this.quoteCheckoutService.checkSubmission) {
      this.quoteCheckoutService.checkSubmission.next(false)
    }
  }
}
